import { useCallback, useMemo, useState } from 'react';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import { useGetWarrantyAuditResultsQuery } from '../../../../../api/endpoints/warrantyAudit';

const useAuditList = () => {
    const { getCurrentLanguageId } = useLanguage();
    const languageId = getCurrentLanguageId();

    const [filters, setFilters] = useState({
        bosBranchCode: null,
        fromDate: null,
        toDate: null
    });

    const queryArgs = useMemo(
        () => ({
            languageId,
            bosBranchCode: filters.bosBranchCode || undefined,
            bosBranchSiteCode: filters.bosBranchCode || undefined,
            fromDate: filters.fromDate ? filters.fromDate.toISOString() : undefined,
            toDate: filters.toDate ? filters.toDate.toISOString() : undefined
        }),
        [languageId, filters]
    );

    const { data: results = [], isLoading, isFetching, refetch } = useGetWarrantyAuditResultsQuery(queryArgs);

    const updateFilter = useCallback((key, value) => {
        setFilters((prev) => ({ ...prev, [key]: value }));
    }, []);

    // GenericTableFilter "Uygula" ile tüm filtreleri tek seferde uygular
    const applyFilters = useCallback((next = {}) => {
        setFilters({
            bosBranchCode: next.bosBranchCode || null,
            fromDate: next.fromDate || null,
            toDate: next.toDate || null
        });
    }, []);

    const resetFilters = useCallback(() => {
        setFilters({ bosBranchCode: null, fromDate: null, toDate: null });
    }, []);

    return {
        results,
        isLoading: isLoading || isFetching,
        filters,
        updateFilter,
        applyFilters,
        resetFilters,
        refetch
    };
};

export default useAuditList;
